import { render, staticRenderFns } from "./ModalCourses.vue?vue&type=template&id=1715cab5&scoped=true"
import script from "./ModalCourses.vue?vue&type=script&lang=ts"
export * from "./ModalCourses.vue?vue&type=script&lang=ts"
import style0 from "./ModalCourses.vue?vue&type=style&index=0&id=1715cab5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1715cab5",
  null
  
)

export default component.exports